import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgArrowLeftUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7a1 1 0 0 1 1-1h8.5a1 1 0 1 1 0 2H9.414l8.293 8.293a1 1 0 0 1-1.414 1.414L8 9.414V15.5a1 1 0 1 1-2 0V7Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgArrowLeftUp)
